module.exports = __webpack_public_path__ + "img/close-2.3dc74671.png";